import React, {useCallback, useContext, useEffect, useState} from "react";
import "./RotatableBuilding.scss";
import {useDispatch, useSelector} from "react-redux";
import ImageMapper from "react-img-mapper";
import "./ProjectPois.scss";
import {AppContext} from "../../context";
import {Card, Spinner} from "react-bootstrap";
import {SCREEN_SIZES} from "../../config/constants";
import {loadCurrentData} from "../../store/actions";

const {detect} = require("detect-browser");
const browser = detect();

const ProjectPois = ({
                         url,
                         dimensions,
                         dragging,
                         setAppState,
                         currentHeight,
                         currentWidth,
                         setCurrentHeight,
                         setCurrentWidth,
                         setHoveredArea,
                         hoveredArea,
                         infoArrayIds,
                         infoArrayIds2
                     }) => {


    const [MAP, setMap] = useState({name: "my-map", areas: []});
    const [menuDivWidth, setMenuDivWidth] = useState(0);
    const {pois} = useSelector(state => state.data);
    const {coordinates} = useSelector(state => state.coordinates);
    const {currentPoi} = useSelector(state => state.data);
    const state = useContext(AppContext);
    const dispatch = useDispatch();
    const {
        isMenuOpen,
        imageIndex,
        appLoading,
        imgMapprRef
    } = state;

    useEffect(() => {
            let createMap = [];
            // if (!dragging) {
            let differenceWidth = 0;
            let differenceHeight = 0;
            var ratio = 1920 / 1080;
            var width = currentHeight * ratio;
            var height = currentHeight;
            if (width > currentWidth) {
                width = currentWidth;
                height = currentWidth / ratio;
            }

            const screenSize = window.innerWidth;
            const coordinateList = coordinates.filter(item => item.coordinates["_vertices"]);
            createMap = coordinateList.map(item => {
                if (item && item.coordinates && item.coordinates["_vertices"]) {
                    let d = 6;
                    let coordinatesSplit = item.coordinates["_vertices"].split(";");
                    let coordinatesParam = coordinatesSplit.map(item => {
                        d++;
                        let n = item.split(",");
                        if (screenSize > 1500) {
                            const currentWithForDiv = document.body.offsetWidth - 280;
                            differenceWidth = (1920 - currentWithForDiv - 280) / 2;
                            differenceHeight = (1080 - currentHeight) / 2;
                            n[0] = (n[0]) - differenceWidth - 140;
                            n[1] = (n[1]) - differenceHeight;
                        } else {
                            differenceWidth = 1920 / width;
                            differenceHeight = 1080 / height;
                            n[0] = ((n[0] / differenceWidth) + ((currentWidth - width) / 2));
                            n[1] = ((n[1] / differenceHeight) + ((currentHeight - height) / 2));
                        }
                        return n;
                    });

                    const poi = pois.filter(poi => poi.id === item.id);
                    const hoverdArea = (!dragging && !infoArrayIds.includes(+currentPoi?.id) && currentPoi?.id === poi[0].id) ? "rgba(232, 16, 22,0.4)" : "";
                    return {
                        id: poi[0].id,
                        name: poi[0],
                        shape: "poly",
                        coords: coordinatesParam.flat(),
                        preFillColor: parseInt(poi[0].visible) ? hoverdArea : "rgba(232, 16, 22,0.4)",
                        fillColor: parseInt(poi[0].visible) ? infoArrayIds.includes(+poi[0].id) ? "transparent" : "rgba(232, 16, 22,0.7)" : "rgba(153, 7, 6,0.5)",
                        lineWidth: infoArrayIds.includes(+poi[0].id) ? 0 : 1,
                        disabled: dragging
                    };
                }
                return [];
            });
            setMap({...MAP, areas: createMap});
            // }
            return (() => {
            })
        }, [currentPoi, coordinates, currentWidth, currentHeight, imageIndex, dragging, dimensions, pois, infoArrayIds, appLoading, window.innerHeight, window.innerWidth]
    );

    useEffect(() => {
        const windowWidth = window.innerWidth;
        if (windowWidth > SCREEN_SIZES.tablet[1]) {
            setCurrentWidth(window.innerWidth - 280);
            setCurrentHeight(window.innerHeight);
        } else if ((navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/iPhone/i)) && (browser.name !== "safari" && browser.name !== "ios")) {
            const d = document.body;
            setCurrentWidth(d.offsetWidth);
            setCurrentHeight(d.offsetHeight);
        } else {
            setCurrentWidth(window.innerWidth);
            setCurrentHeight(window.innerHeight);
        }
    }, [dimensions]);

    const getTipPosition = (area) => {
        return {top: `${area.center[1]}px`, left: `${area.center[0] + 200}px`};
    };

    useEffect(() => {
        let img = document.querySelector("#imageMapperDiv img");
        img.setAttribute("draggable", false);
        img.setAttribute("ondragstart", "return false;");
    }, [MAP]);


    useEffect(() => {
        if (isMenuOpen) {
            setMenuDivWidth(document.getElementById("sidebar").offsetWidth);
        }
    }, [menuDivWidth]);

    const load = useCallback(() => {
        setMap({...MAP});
    }, [MAP]);

    const enterArea = (area) => {
        setHoveredArea(area);
    }

    const onClickedInsideImage = (area, index, event) => {
        event.stopPropagation()
        // if (window.innerWidth < SCREEN_SIZES.tablet[1]) {
        setAppState({prop: "secondPage", value: {filterOpen: true, id: area.name.lot}});
        setAppState({prop: "isMenuOpen", value: true});
        setHoveredArea(area)
        dispatch(loadCurrentData(area.name.lot));
        // }
    };

    const moveOnImage = () => {
        setHoveredArea(null);
    };

    // const handleMoreClick = (id) => {
    //   setAppState({ prop: "secondPage", value: { filterOpen: true, imageOpen: false, id: id } });
    //   setAppState({ prop: "isMenuOpen", value: true });
    // };
    const removeSelected = () => {
        if (window.innerWidth > SCREEN_SIZES.tablet[1]) {
            setHoveredArea(null);
            dispatch(loadCurrentData());
        }
    };

    return (
        <>
            <div id="imageMapperDiv">
                {window.innerWidth < SCREEN_SIZES.tablet[1] && dragging && Object.keys(currentPoi).length > 0 && !infoArrayIds.includes(+currentPoi?.id) &&
                    <div className="spinner-load-main">
                        <Spinner animation="border" role="status" variant="danger">
                            <span className="visually-hidden"/>
                        </Spinner>
                    </div>
                }

                <ImageMapper src={url} map={MAP}
                             onLoad={() => load()}
                             onMouseEnter={area => enterArea(area)}
                             onImageMouseMove={evt => moveOnImage(evt)}
                             onTouchStart={(area, index, event) => onClickedInsideImage(area, index, event)}
                             onClick={(area, index, event) => onClickedInsideImage(area, index, event)}
                             onMouseDown={(area, index, event) => onClickedInsideImage(area, index, event)}
                             onImageClick={(event) => removeSelected()}
                             width={currentWidth}
                             height={currentHeight}
                             containerRef={imgMapprRef}
                />
                {
                    window.innerWidth > SCREEN_SIZES.tablet[1] && !dragging && hoveredArea && (!infoArrayIds.includes(parseInt(hoveredArea.name.id)) && !infoArrayIds2.includes(parseInt(hoveredArea.name.id))) &&
                    <div id='apartmentPopup' className="apartmentPopup" style={{...getTipPosition(hoveredArea)}}>
                        {hoveredArea && hoveredArea.name &&
                            <Card style={{width: "18rem"}}>
                                <Card.Body className={"p-2"}>
                                    <Card.Title>{hoveredArea.name.title}</Card.Title>
                                    <Card.Text>
                                        {hoveredArea.name.surface} sq ft </Card.Text>
                                    <Card.Text
                                        className={'mt-2 mb-0 popup-description'}>{hoveredArea.name.surface_sub}</Card.Text><Card.Text>
                                    {hoveredArea.name.description}
                                </Card.Text>
                                </Card.Body>
                            </Card>
                        }
                    </div>
                }
            </div>
        </>
    );
};
export default ProjectPois;
